import { FC, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Loading } from 'components/primitive';
import PAmultiDetailsPage from './PAmultiDetailsPage.tsx';
import { ParcelData } from 'components/fragment/ParcelViewModal/ParcelViewModal.props.tsx';

const PAmultiDetailsContainer: FC = () => {
  const params = useParams();
  const location = useLocation();
  const multiParcelsDataState = location.state?.multiParcelsData;
  const [loading, setLoading] = useState(true);
  const [multiParcelsData, setMultiParcelsData] = useState<ParcelData[]>([]);

  useEffect(() => {
    if (multiParcelsDataState) {
      setMultiParcelsData(multiParcelsDataState);
      setLoading(false);
    }
  }, [params, multiParcelsDataState]);

  return (
    <>
      {loading && <Loading message={'Loading data'} />}
      {!loading && <PAmultiDetailsPage multiParcelsData={multiParcelsData} />}
    </>
  );
};

export default PAmultiDetailsContainer;
